import gql from 'graphql-tag';

export const HOME_PAGE_TABS_FRAGMENT = gql`
  fragment homePageTabSection on HomePageTabSectionType {
    tabSectionForPeopleHeadline
    tabSectionForPeopleDescription
    tabSectionForPeopleButtonText
    tabSectionForPeopleButtonLink
    tabSectionForPeopleImage
    tabSectionForOrganizationsHeadline
    tabSectionForOrganizationsDescription
    tabSectionForOrganizationsButtonText
    tabSectionForOrganizationsButtonLink
    tabSectionForOrganizationsImage
  }
`;
